import { useState } from "react";

const usePagination = (initialPageSize = 25) => {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: initialPageSize,
  });

  const handlePageSizeChange = (event) => {
    setPagination((prev) => ({
      ...prev,
      pageSize: Number(event.target.value),
    }));
  };

  return {
    pagination,
    setPagination,
    handlePageSizeChange,
  };
};

export default usePagination;
